import * as yup from 'yup';

export const userNameSchema = yup
  .string()
  .required('Name is required')
  .max(50, 'Name must be less than 50 characters')
  .matches(/^[^<]*$/, 'Name must not contain the "<" character');

export const orgSchema = yup
  .string()
  .required('Company name is required')
  .max(50, 'Company name must be less than 50 characters');

export const phoneSchema = yup
  .string()
  .required('Phone number is required')
  .matches(/^[0-9]{10,14}$/, 'Phone number must be between 10 and 14 digits');

export const emailSchema = yup
  .string()
  .required('Email is required')
  .email('Invalid email format')
  .max(50, 'Email must be less than 50 characters');

export const passwordSchema = yup
  .string()
  .required('Password is required')
  .min(8, 'Password must be at least 8 characters')
  .max(50, 'Password must be less than 50 characters')
  .matches(
    /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/,
    'Password must have at least one capital letter, one special character, one number, and be at least 8 characters long'
  );

export const answerSchema = yup.string().max(50, 'Answer must be less than 50 characters');
